/**
 * Enables/disables next step button
 * @param {Boolean} toogle
 */
function toggleNextStepButtonEnable(toogle) {
  $('.js-sample-next')
    .attr('disabled', !toogle)
    .toggleClass('btn-inactive', !toogle);
}

/**
 * Gets checkbox answers.
 * @param {Object} $input - Jquery selected input nodes
 * @returns {String} Answers divided by pipe
 */
function getCheckoxAnswers($input) {
  const answers = [];
  $.each($input, (index, input) => answers.push(input.value));

  return answers.join('|');
}

/**
 * Callback called when textarea value is changed by user.
 * If answer is required toggles next step button.
 * @param {Event} event
 * @param {Object} classInstance - sample class instance
 */
export function onTextareaInput(event, classInstance) {
  const value = $.trim(event.currentTarget.value);
  classInstance.answer = value;

  if (classInstance.questionIsRequired) {
    toggleNextStepButtonEnable(value !== '');
  }
}

/**
  * Callback when question input is checked.
  * Adds answer to class. Toggles next step button if answer is required.
  * @param {Object} classInstance
  */
export function onChecked(classInstance) {
  const $input = $('.js-sample-question-input:checked');
  const answered = $input.length !== 0;

  classInstance.answer = $input.attr('type') === 'checkbox' ? getCheckoxAnswers($input) : $input.val();
  if (classInstance.questionIsRequired) {
    toggleNextStepButtonEnable(answered);
  }
}

/**
 * Gets question type
 * @returns {String} - question input tag/type
 */
function getQuestionType() {
  const $input = $('.js-sample-question-input');
  if ($input.length) {
    return $input.attr('type');
  }
  if ($('.js-sample-question-textarea').length) {
    return 'textarea';
  }
}

/**
 * Selects the checkbox by index on page
 * @param {String | Number} index - index of checkbox to be checked
 */
function selectCheckbox(index) {
  $(`.js-sample-question-input:eq(${index})`).attr('checked', true);
}

/**
 * Sets answer when going back to answer step
 * @param {Object} classInstance
 */
export function setAnswer(classInstance) {
  const questionType = getQuestionType();
  if (questionType === 'radio') {
    $('.js-sample-question-input').each((index, input) => {
      if (input.value === classInstance.answer) {
        input.checked = true;
      }
    });
  } else if (questionType === 'textarea') {
    $('.js-sample-question-textarea').val(classInstance.answer);
  } else {
    const multipleAnswers = classInstance.answer.split('|');
    if (multipleAnswers.length) {
      multipleAnswers.forEach(answer => selectCheckbox(answer));
    } else {
      selectCheckbox(classInstance.answer);
    }
  }
}

/**
 * Adds question step events
 * @param {Object} classInstance
 */
export function addQuestionEvents(classInstance) {
  const questionType = getQuestionType();
  if (questionType === 'checkbox' || questionType === 'radio') {
    $('.js-sample-question-input').change(() => onChecked(classInstance));
  } else {
    $('.js-sample-question-textarea').on('keyup change', event => onTextareaInput(event, classInstance));
  }
  $('.js-sample-next').click(() => {
		classInstance.onStepNav();
	});
  $('.js-sample-previous').click(() => classInstance.onStepNav('previous'));
}
